
import { Component, ModelSync, Prop, Vue, Watch } from "vue-property-decorator";
import ContainerFrame from "../ContainerFrame.vue";
import {FirmwareVersion} from"@/api/dtos/FirmwareVersion.schema";
import EditFrame from "../EditFrame.vue";
import moment from "moment";
import api from "@/api";
import CancelButton from '../buttons/CancelButton.vue'
import AddButton from '../buttons/AddButton.vue'
import DangerDialog from '../dialogs/DangerDialog.vue'
import { getDeviceTypes } from "@/api/stations";

@Component({
  components: {
    ContainerFrame,
    EditFrame,
    CancelButton,
    AddButton
  },
})
export default class CreateFirmwareDialog extends Vue {
  @ModelSync("value", "input")
  show!: boolean;

  @Prop({ required: true })
  firmwareversion!: FirmwareVersion;


  hardwareTypes: string[] = ["BIKE_PARK_BOX_CONTROLLER"];

  fileRules = [
    (v: File | null) => !!v || "Pflichtfeld",
    (v: File | null) =>
      !v || v.name.toLowerCase().endsWith(".bin") || "Nur .bin Dateien sind erlaubt!",
  ];

  versionRules = [
    (v: string) => !!v || "Pflichtfeld",
    (v: string) =>
      /^\d+(\.\d+){0,2}$/.test(v) ||
      "Version muss numerisch sein, z. B. 1, 1.0 oder 1.0.2",
  ];

  save () :void {
    const form = this.$refs.form as any;
    if (form && typeof form.validate === "function") {
      const isValid = form.validate();
      if (!isValid) {
        return;
      }
    }

    this.$emit('save',this.firmwareversion)
  }

  onCancel () {
    this.$emit('cancel')
  }

  async mounted(){

  }

  moment = moment;
}
